import React from 'react';
import { primaryM, surfaceM, grayMediumM, primaryDisabledM } from 'web-ui-kit/colors';

function AddToCartIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? primaryM : _ref$iconColor,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'opaque' : _ref$variant;

  var hoverColor = function hoverColor() {
    switch (iconColor) {
      case primaryM:
        return primaryDisabledM;

      case surfaceM:
        return grayMediumM;
    }
  };

  if (variant === 'filled' || variant === 'disabled') {
    return (
      /*#__PURE__*/
      React.createElement("svg", {
        "aria-label": "add to cart",
        className: className,
        role: "img",
        width: size,
        viewBox: "0 0 22 23",
        fill: "none",
        style: style,
        xmlns: "http://www.w3.org/2000/svg"
      },
      /*#__PURE__*/
      React.createElement("path", {
        d: "M21.5 6.7541C21.5 9.96147 18.8929 12.5637 15.6743 12.5637C12.4557 12.5637 9.84863 9.96147 9.84863 6.7541C9.84863 3.54672 12.4557 0.944458 15.6743 0.944458C18.8929 0.944458 21.5 3.54672 21.5 6.7541Z",
        stroke: variant === 'disabled' ? hoverColor() : iconColor
      }),
      /*#__PURE__*/
      React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.9109 12.658C17.2156 12.9202 16.4617 13.0637 15.6743 13.0637C12.5334 13.0637 9.9272 10.7804 9.43299 7.78708H4.10662L3.7655 6.19048C3.7059 5.91155 3.43476 5.69288 3.14885 5.69318H0.629769C0.281948 5.69318 0 5.97442 0 6.32135C0 6.66828 0.281948 6.94952 0.629769 6.94952H2.63716L4.80199 17.1377C4.88764 17.5212 5.13963 17.8404 5.458 17.8379H15.9542C16.2869 17.8425 16.5929 17.5416 16.5929 17.2097C16.5929 16.8778 16.2869 16.5768 15.9542 16.5815H5.96969L5.70071 15.3251H16.7938C17.0758 15.3231 17.3422 15.1088 17.4039 14.8344L17.8168 13.0694L17.8149 13.07L17.9109 12.658ZM5.458 20.3505C5.458 19.2015 6.40532 18.2566 7.55723 18.2566C8.70914 18.2566 9.65646 19.2015 9.65646 20.3505C9.65646 21.4995 8.70914 22.4444 7.55723 22.4444C6.40532 22.4444 5.458 21.4995 5.458 20.3505ZM11.7557 20.3505C11.7557 19.2015 12.703 18.2566 13.8549 18.2566C15.0068 18.2566 15.9542 19.2015 15.9542 20.3505C15.9542 21.4995 15.0068 22.4444 13.8549 22.4444C12.703 22.4444 11.7557 21.4995 11.7557 20.3505ZM8.39692 20.3505C8.39692 19.8805 8.02845 19.513 7.55723 19.513C7.08606 19.513 6.71754 19.8805 6.71754 20.3505C6.71754 20.8205 7.08606 21.1881 7.55723 21.1881C8.02845 21.1881 8.39692 20.8206 8.39692 20.3505ZM14.6946 20.3505C14.6946 19.8805 14.3261 19.513 13.8549 19.513C13.3838 19.513 13.0152 19.8805 13.0152 20.3505C13.0152 20.8205 13.3838 21.1881 13.8549 21.1881C14.3261 21.1881 14.6946 20.8206 14.6946 20.3505Z",
        fill: variant === 'disabled' ? hoverColor() : iconColor
      }),
      /*#__PURE__*/
      React.createElement("path", {
        d: "M18.8369 7.20475H16.1259V9.90888H15.2222V7.20475H12.5112V6.30337H15.2222V3.59924H16.1259V6.30337H18.8369V7.20475Z",
        fill: variant === 'disabled' ? hoverColor() : iconColor
      }))
    );
  }

  return (
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": "add to cart",
      className: className,
      role: "img",
      width: size,
      height: size,
      viewBox: "0 0 25 25",
      fill: "none",
      style: style,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.2033 5.5H4.89062L4.48437 3.59375C4.4134 3.26073 4.0905 2.99965 3.75 3H0.75C0.335775 3 0 3.33579 0 3.75C0 4.16421 0.335775 4.5 0.75 4.5H3.14062L5.71875 16.6641C5.82075 17.122 6.12085 17.5031 6.5 17.5H19C19.3962 17.5055 19.7607 17.1463 19.7607 16.75C19.7607 16.3537 19.3962 15.9944 19 16H7.10937L6.78905 14.5H20C20.3358 14.4975 20.6531 14.2417 20.7265 13.9141L21.2182 11.8068C20.7088 11.9921 20.1672 12.1104 19.6041 12.1509L19.4062 13H6.47655L5.20312 7H13.2241C13.1863 6.72764 13.1667 6.44943 13.1667 6.16665C13.1667 5.94131 13.1791 5.71888 13.2033 5.5ZM6.5 20.5C6.5 19.1282 7.62817 18 8.99999 18C10.3718 18 11.5 19.1282 11.5 20.5C11.5 21.8718 10.3718 23 8.99999 23C7.62817 23 6.5 21.8718 6.5 20.5ZM14 20.5C14 19.1282 15.1282 18 16.5 18C17.8718 18 19 19.1282 19 20.5C19 21.8718 17.8718 23 16.5 23C15.1282 23 14 21.8718 14 20.5ZM9.99999 20.5C9.99999 19.9388 9.56117 19.5 8.99999 19.5C8.43887 19.5 7.99999 19.9389 7.99999 20.5C7.99999 21.0612 8.43887 21.5 8.99999 21.5C9.56117 21.5 9.99999 21.0612 9.99999 20.5ZM17.5 20.5C17.5 19.9388 17.0612 19.5 16.5 19.5C15.9389 19.5 15.5 19.9389 15.5 20.5C15.5 21.0612 15.9389 21.5 16.5 21.5C17.0612 21.5 17.5 21.0612 17.5 20.5Z",
      fill: primaryM
    }),
    /*#__PURE__*/
    React.createElement("ellipse", {
      cx: "19.5",
      cy: "5.83301",
      rx: "5.5",
      ry: "5.50001",
      fill: primaryM
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M22.25 6.22587H19.8929V8.58301H19.1071V6.22587H16.75V5.44015H19.1071V3.08301H19.8929V5.44015H22.25V6.22587Z",
      fill: surfaceM
    }))
  );
}

export default AddToCartIcon;